import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import {
  signUp as signUpAction,
  SignUpAction,
} from '@triare/auth-redux/dist/saga/auth/signUp';
import { connect } from 'react-redux';
import { Action } from '@triare/auth-redux';
import { IconTipping } from '../../../../Common/Icon';
import { useAuth } from '../../../../../store/auth';

interface ForgotPasswordProps {
  email?: string;
  prevPayload?: Partial<SignUpAction>;
  onClose?: () => void;
  setSignUpOpen?: () => void;
  isOpen?: boolean;
  // redux props:
  signUp: (payload: SignUpAction) => Action;
}

function Information({
  prevPayload,
  onClose,
  setSignUpOpen,
  isOpen,
  // redux props:
  signUp,
}: ForgotPasswordProps): React.ReactElement {
  const { signUp: { loading } } = useAuth();

  const [cooldown, setCooldown] = useState(0);

  const resendSignUp = () => {
    if (prevPayload?.email && prevPayload?.password) {
      signUp(prevPayload as SignUpAction);
      setCooldown(60); // start 60 sec cooldown
    }
  };

  useEffect(() => {
    if (cooldown <= 0) return;
    const timer = setInterval(() => {
      setCooldown((prev) => prev - 1);
    }, 1000);

    // eslint-disable-next-line consistent-return
    return () => clearInterval(timer);
  }, [cooldown]);

  return (
    <Modal onCancel={onClose} open={isOpen} footer={null} destroyOnClose>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <IconTipping />
        <h4 style={{ marginTop: '15px' }}>
          We&apos;ve sent a verification link to your email.
          Please check your inbox (and your spam folder) and click the link to verify your email address.
        </h4>
        <span style={{ fontWeight: 300, marginTop: 15 }}>
          Email sent{prevPayload?.email ? ` to ${prevPayload?.email}` : ''}
        </span>
        {/* <Button */}
        {/*  style={{ marginTop: '20px' }} */}
        {/*  type="primary" */}
        {/*  size="large" */}
        {/*  onClick={() => { */}
        {/*    // onClose?.(); */}
        {/*    // setSignUpOpen?.(); */}
        {/*    resendSignUp(); */}
        {/*  }} */}
        {/*  loading={loading} */}
        {/*  disabled={cooldown > 0} */}
        {/* > */}
        {/*  /!* Back to Sign Up *!/ */}
        {/*  {cooldown > 0 ? `Resend in ${cooldown}s` : 'Resend Email'} */}
        {/* </Button> */}
      </div>
    </Modal>
  );
}

export default connect(null, {
  signUp: signUpAction,
})(Information);
